/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ManagerAccountControllerDtoMyNameChangeRequest model module.
 * @module model/ManagerAccountControllerDtoMyNameChangeRequest
 * @version 1.0
 */
class ManagerAccountControllerDtoMyNameChangeRequest {
    /**
     * Constructs a new <code>ManagerAccountControllerDtoMyNameChangeRequest</code>.
     * @alias module:model/ManagerAccountControllerDtoMyNameChangeRequest
     * @param newName {String} 
     */
    constructor(newName) { 
        
        ManagerAccountControllerDtoMyNameChangeRequest.initialize(this, newName);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, newName) { 
        obj['newName'] = newName;
    }

    /**
     * Constructs a <code>ManagerAccountControllerDtoMyNameChangeRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerAccountControllerDtoMyNameChangeRequest} obj Optional instance to populate.
     * @return {module:model/ManagerAccountControllerDtoMyNameChangeRequest} The populated <code>ManagerAccountControllerDtoMyNameChangeRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerAccountControllerDtoMyNameChangeRequest();

            if (data.hasOwnProperty('newName')) {
                obj['newName'] = ApiClient.convertToType(data['newName'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerAccountControllerDtoMyNameChangeRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerAccountControllerDtoMyNameChangeRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ManagerAccountControllerDtoMyNameChangeRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['newName'] && !(typeof data['newName'] === 'string' || data['newName'] instanceof String)) {
            throw new Error("Expected the field `newName` to be a primitive type in the JSON string but got " + data['newName']);
        }

        return true;
    }


}

ManagerAccountControllerDtoMyNameChangeRequest.RequiredProperties = ["newName"];

/**
 * @member {String} newName
 */
ManagerAccountControllerDtoMyNameChangeRequest.prototype['newName'] = undefined;






export default ManagerAccountControllerDtoMyNameChangeRequest;

